import Route from '@ember/routing/route';
import EmberObject from '@ember/object';
import { inject as service } from '@ember/service';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { BANNER_MESSAGE_TYPES } from 'sh-www/services/states/application';

/**
 * @param {Assignment|null} assignment
 * @param {AssignmentDetailsApplicationList|null} assignmentDetailsAppList
 * @return {boolean}
 */
const showAssignmentBanner = (assignment, assignmentDetailsAppList) => {
  if (!assignment) return false;
  if (assignment.type !== ASSIGNMENT.TYPES.STANDARD) return false;

  if (!assignmentDetailsAppList) return false;
  if (!assignmentDetailsAppList.pendingCount) return false;
  if (!assignmentDetailsAppList.hiredCount) return false;

  return true;
};

class PostingRoute extends Route {
  /**
   * Register services
   */
  @service('state-managers/application') applicationStateManager;
  @service session;
  @service('states/routes/posting') state;
  @service('state-managers/routes/posting') stateManager;

  /**
   * @inheritDoc
   */
  activate() {
    super.activate(...arguments);

    if (!this.session.currentUser.isBuyer) {
      return;
    }

    const assignmentDetailsAppList = this.state.assignmentDetailsApplicationList;
    const assignment = this.state.assignment;

    if (showAssignmentBanner(assignment, assignmentDetailsAppList)) {
      this.applicationStateManager.setBannerMessage(
        BANNER_MESSAGE_TYPES.PENDING_PROPOSALS_FOR_ACTIVE_APPLICATION,
        true,
        EmberObject.create({ assignment })
      );
    }

    this.set('state.buyerFeedbackAssignment', assignment);
  }

  /**
   * @inheritDoc
   */
  deactivate() {
    super.deactivate(...arguments);

    // Dismiss any active banner message.
    this.set('state.buyerFeedbackAssignment', null);
    this.applicationStateManager.dismissBannerMessage();
  }

  /**
   * @inheritDoc
   */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      // Reset the state for the buyer controller upon exiting this route namespace
      const buyerController = this.controllerFor('posting/buyer');
      if (buyerController) {
        buyerController.resetController();
      }
    }
  }
}

export default PostingRoute;
